/**
 * Pre-compiled pt-BR messages for Alert
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { dismiss: `Dispensar` };
